import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { isAbsoluteUrl } from '../utils/formatImageUrls';

interface CardZoomProps {
  imageUrl: string;
  cardName: string;
  onClose: () => void;
}

export default function CardZoom({ imageUrl, cardName, onClose }: CardZoomProps) {
  const [scale, setScale] = useState(1);
  const [validatedUrl, setValidatedUrl] = useState(imageUrl);
  
  // Validate image URL
  useEffect(() => {
    if (!isAbsoluteUrl(imageUrl)) {
      console.warn('[CardZoom] Invalid image URL provided:', imageUrl);
      // Fallback to a safe default
      setValidatedUrl('https://yjzlookljahphgxcwpnv.supabase.co/storage/v1/object/public/pokemon-images/placeholder.png');
    } else {
      setValidatedUrl(imageUrl);
    }
  }, [imageUrl]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleWheel = (e: React.WheelEvent) => {
    e.preventDefault();
    const delta = e.deltaY * -0.01;
    const newScale = Math.min(Math.max(1, scale + delta), 4);
    setScale(newScale);
  };

  return (
    <div 
      className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center animate-fade-in"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white/60 hover:text-white transition-colors"
        aria-label="Close"
      >
        <X size={24} />
      </button>
      
      <div 
        className="relative overflow-hidden"
        onClick={e => e.stopPropagation()}
        onWheel={handleWheel}
      >
        <img
          src={validatedUrl}
          alt={cardName}
          className="max-h-[90vh] w-auto transition-transform duration-200"
          style={{
            transform: `scale(${scale})`,
            transformOrigin: 'center'
          }}
          draggable={false}
        />
      </div>
    </div>
  );
}